import { render } from "./Changelogs.vue?vue&type=template&id=6a39f345&scoped=true&ts=true"
import script from "./Changelogs.vue?vue&type=script&lang=ts"
export * from "./Changelogs.vue?vue&type=script&lang=ts"

import "./Changelogs.vue?vue&type=style&index=0&id=6a39f345&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a39f345"]])

export default __exports__